// extracted by mini-css-extract-plugin
export default {"content-block":"ContentBlock_content-block__G9FyC","download":"ContentBlock_download__3srmZ","quote":"ContentBlock_quote__tRJ7i","btn":"ContentBlock_btn__GdxaI"};